import { render, staticRenderFns } from "./Upgradeexplain.vue?vue&type=template&id=4d77a086&scoped=true"
import script from "./Upgradeexplain.vue?vue&type=script&lang=js"
export * from "./Upgradeexplain.vue?vue&type=script&lang=js"
import style0 from "./Upgradeexplain.vue?vue&type=style&index=0&id=4d77a086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d77a086",
  null
  
)

export default component.exports